import "./BoardSidebar.scss";
import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function BoardSidebar({
  boards,
  currentBoard,
  onBoardSelect,
  onCreateBoard,
  onEditBoard,
  onDeleteBoard,
  canManageBoards,
  isCollapsed,
  showToolTip,
  closeToolTip,
}) {
  const { t } = useTranslation();
  const handleBoardClick = (board) => {
    onBoardSelect(board);
  };

  return (
    <div className={`board-sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="board-list">
        {boards.length === 0 && !isCollapsed ? (
          <div className="empty-state">
            {canManageBoards
              ? t("tasks.board.emptyCanCreate")
              : t("tasks.board.empty")}
          </div>
        ) : boards.length > 0 ? (
          boards.map((board) => (
            <div
              key={board._id}
              className={`board-item ${currentBoard?._id === board._id ? "active" : ""}`}
              onClick={() => handleBoardClick(board)}
              onMouseEnter={
                isCollapsed
                  ? (e) => showToolTip(e, "left-center", board.name)
                  : undefined
              }
              onMouseLeave={isCollapsed ? closeToolTip : undefined}
            >
              {board.icon && (
                <span className="board-icon material-symbols-outlined">
                  {board.icon}
                </span>
              )}
              {!isCollapsed && <span className="board-name">{board.name}</span>}
              {canManageBoards && !isCollapsed && (
                <div className="board-actions">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onEditBoard(board);
                    }}
                    title={t("tasks.board.edit")}
                  >
                    <span className="material-symbols-outlined">edit</span>
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteBoard(board);
                    }}
                    title={t("tasks.board.delete")}
                  >
                    <span className="material-symbols-outlined">delete</span>
                  </button>
                </div>
              )}
            </div>
          ))
        ) : null}
      </div>
    </div>
  );
}

BoardSidebar.propTypes = {
  boards: PropTypes.array.isRequired,
  currentBoard: PropTypes.object,
  onBoardSelect: PropTypes.func.isRequired,
  onCreateBoard: PropTypes.func.isRequired,
  onEditBoard: PropTypes.func,
  onDeleteBoard: PropTypes.func,
  canManageBoards: PropTypes.bool,
  isCollapsed: PropTypes.bool,
  showToolTip: PropTypes.func,
  closeToolTip: PropTypes.func,
};

BoardSidebar.defaultProps = {
  currentBoard: null,
  onEditBoard: () => {},
  onDeleteBoard: () => {},
  canManageBoards: false,
  isCollapsed: false,
  showToolTip: () => {},
  closeToolTip: () => {},
};

export default BoardSidebar;
